import api from "../api/axiosConfig";

const productService = {
  getAll: () => api.get("/getProducts"),
  getLowStock: () => api.get("/getLowStock"),
  create: (data) => api.post("/createProduct", data),
  update: (id,data) => api.put("/products/" + id, data),
  delete: (id) => api.delete("/products/" + id),
  updateStock: (id, delta, production = {}) =>
    api.put("/updateStock", { id, delta, ...production }),
};

export default productService;
